import React, { useContext, useEffect, useState } from 'react'
import { NavLink as Link, useLocation, useNavigate, useSearchParams } from 'react-router-dom'
import styled from 'styled-components'

import '../../assets/css/global.css'
import '../../assets/css/rhybus.css'
import '../../assets/css/variables.css'
import '../../assets/icons/style.css'
import { mpfRListsHttp } from '../../assets/ts/api/mpf-r-lists-http'
import { getCurrentUTCDate } from '../../assets/ts/date-and-time/date-and-time'
import { defaultToEmptyString } from '../../assets/ts/formatting/formatting'
import { UserContext } from '../../store/user-context-provider'
import { SurveyFormCols, SurveyRequiredCols } from '../../utils/constants/global-list-columns'
import { SURVEY_FORM_LIST, SURVEY_REQUIRED_LIST } from './customerSurvey'
import './surveyForm.css'

// eslint-disable-next-line import/exports-last
export const Navlink = styled(Link)`}`
const surveyQuestions = {
  [SurveyFormCols.MPFMadeItEasyForMe]:
    'MPF made it easy for me to find a solution/answer to my issue.',
  [SurveyFormCols.OverallSatisfactionForTheResolution]:
    'How would you rate your overall satisfaction for the resolution provided?',
  [SurveyFormCols.SatisfactionOnQualityOfYourService]:
    'How satisfied are you with the quality of your service?',
  [SurveyFormCols.SatisfactionOnResolutionTimeliness]:
    'How satisfied are you with resolution timeliness?',
}

const responsesIcons = [
  {
    class: 'verysatisfiedRead',
    label: 'Very Satisfied',
    title: 'Very Satisfied'
  },
  {
    class: 'satisfiedRead',
    label: 'Satisfied',
    title: 'Satisfied',
  },
  {
    class: 'neutralRead',
    label: 'Neutral',
    title: 'Neutral'
  },
  {
    class: 'sadRead',
    label: 'Dissatisfied',
    title: 'Dissatisfied'
  },

  {
    class: 'verysadRead',
    label: 'Very Dissatisfied',
    title: 'Very Dissatisfied'
  },
]

const statementResponsesIcons = [
  {
    class: 'verysatisfied',
    label: 'Strongly Agree',
    title: 'Strongly Agree'
  },
  {
    class: 'satisfied',
    label: 'Agree',
    title: 'Agree'
  },
  {
    class: 'neutral',
    label: 'Neutral',
    title: 'Neutral'
  },
  {
    class: 'sad',
    label: 'Disagree',
    title: 'Disagree'
  },

  {
    class: 'verysad',
    label: 'Strongly Disagree',
    title: 'Strongly Disagree'
  },
]
let isDisabled = false
export const SurveyForm = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { userId, } = useContext(UserContext)
  const [ready, setReady] = useState(false)
  const [thanksMessage, setThanksMessage] = useState<any>(false)
  const [surveyDetails, setSurveyDetails] = useState<any>('')
  const [selectedAnswers, setSelectedAnswers] = useState<any>([])
  const [isSubmitting, setIsSubmitting] = useState<any>(false)
  const [filledAnswers, setFilledAnswers] = useState<any>([])
  const [aditionalComment, setAditionalComment] = useState<any>('')
  const [isRequired, setIsRequired] = useState<any>(false)
  const [inquiryID, setInquiryID] = useState<any>('')
  const [savedSurveyForm, setSavedSurveyForm] = useState<any>({})
  const [showAnswers, setShowAnswers] = useState<boolean>(false)

  function buildQuestions(key) {
    const generateOptions = (question, response) => {
      if (savedSurveyForm && savedSurveyForm[question] == undefined) {
        return (
          <li  aria-live={response.title} tabIndex={0} title={response.title}>
            <label htmlFor={question} onClick={() => questionHandler(question, response.label)}>
              <input
                className={response.class}
                name={question}
                type='radio'
                value={response.label}
              />{' '}
              {response.label}
            </label>
          </li>
        )
      } else {
        const isCheked =
          showAnswers &&
          savedSurveyForm &&
          savedSurveyForm[question] &&
          savedSurveyForm[question] == response.label
            ? true
            : false
        return (
          <li>
            <label
              htmlFor={question}
              onClick={() => questionHandler(question, response.label)}
              style={{ cursor: 'default' }}
            >
              <input
                checked={isCheked}
                className={response.class}
                disabled={isDisabled}
                name={question}
                style={{ cursor: 'default' }}
                type='radio'
                value={response.label}
              />{' '}
              {defaultToEmptyString(response.label)}
            </label>
          </li>
        )
      }
    }

    const infoIconHtml = () => {
      return (
        <span className='info-icon'>
            <svg
              height='18'
              viewBox='0 0 20.649 20.649'
              width='18'
              xmlns='http://www.w3.org/2000/svg'
            >
              <path
                d='M9.292,13.422h2.065v2.065H9.292Zm0-8.259h2.065v6.195H9.292ZM10.314,0A10.324,10.324,0,1,0,20.649,10.324,10.319,10.319,0,0,0,10.314,0Zm.01,18.584a8.259,8.259,0,1,1,8.259-8.259A8.257,8.257,0,0,1,10.324,18.584Z'
                fill='#0257a5'
                id='ic_error_outline_24px'
                transform='translate(20.649 20.649) rotate(180)'
              />
            </svg>
            <span className='info-tooltip'>
              <span className='classic'>
                <span className='tooltipdescp'>
                  <p>Mark your answer by clicking on the applicable face/rating.</p>
                </span>
              </span>
            </span>
          </span>
      )
    }
    isDisabled = showAnswers ? true : false
    const options =
      surveyQuestions[key].includes('?') || surveyQuestions[key].includes('.')
        ? responsesIcons
        : statementResponsesIcons
    return (
      <li className='topContainer'>
        <p className='mainQuestion'>
          {' '}
          {defaultToEmptyString(surveyQuestions[key])} <span className='mandatory'>*</span>
        </p>
        {infoIconHtml()}
        <div className='feedbackicons'>
          <ul id='servicerecevied'>
            {options.map((response) => {
              return defaultToEmptyString(generateOptions(key, response))
            })}
          </ul>
        </div>
        {isSubmitting && !filledAnswers.includes(key) && (
          <span className='validationmsg servicereceviedvalidation'>
            This question requires an answer
          </span>
        )}
      </li>
    )
  }

  const questionHandler = (question, answer) => {
    setSelectedAnswers({ ...selectedAnswers, [question]: answer })
    const filled = filledAnswers
    filled.push(question)
    setFilledAnswers(filled)
  }

  const handleComment = (evt) => {
    setAditionalComment(evt.target.value)
  }

  useEffect(() => {
    const surveyGUID = location.pathname.split('/')[2]

    // if (surveyGUID == null || surveyGUID == undefined) {
    //   navigate('/accessdenied')
    // }
    getSurveyData(surveyGUID, SURVEY_REQUIRED_LIST).then((data) => {
      setSurveyDetails(data.survey[0])
      setReady(true)
    })
  }, [])

  useEffect(() => {
    if (surveyDetails) {
      setInquiryID(surveyDetails?.InquiryID)
      setIsRequired(surveyDetails?.IsFeedbackRequired)
      if (!surveyDetails?.IsFeedbackRequired) {
        getSurveyData(surveyDetails?.SurveyGUID, SURVEY_FORM_LIST).then((data) => {
          if (data) {
            setAditionalComment(data.survey[0]?.Comments)
            setSavedSurveyForm(data.survey[0])
          }
        })
      }
      // if (surveyDetails?.CustomerEmail?.toLowerCase() !==
      //  userProfile?.[0]?.DutyEmail?.toLowerCase()) {
      //   navigate('/accessdenied')
      // }
    } else if ((ready && surveyDetails == '') || surveyDetails == undefined) {
     // navigate('/accessdenied')
    }
  }, [ready])

  const getSurveyData = async (surveyGUID, list) => {
    const filterQuery = `(SurveyGUID eq '${surveyGUID}')`

    const surveyData = await mpfRListsHttp().getList(list)
    const survey = await surveyData.query().filter(filterQuery).get()

    return { survey }
  }

  const submitSurveyForm = () => {
    setIsSubmitting(true)
    let validateErrors = false

    Object.keys(surveyQuestions).forEach((key) => {
      if (!filledAnswers.includes(key)) validateErrors = true
    })

    if (!validateErrors) {
      actionUpdates()
    }
  }

  const actionUpdates = async () => {
    const USER_ID = userId
    const updateSurveyRequired = surveyDetails
    updateSurveyRequired[SurveyRequiredCols.IsFeedbackRequired] = false
    updateSurveyRequired[SurveyRequiredCols.ItemModified] = getCurrentUTCDate()
    updateSurveyRequired[SurveyRequiredCols.ItemModifiedBy] = USER_ID
    const addSurveyRequired = {
      [SurveyFormCols.AssignedComponent]: surveyDetails?.AssignedComponent,
      [SurveyFormCols.Comments]: aditionalComment,
      [SurveyFormCols.InquiryID]: surveyDetails?.InquiryID,
      [SurveyFormCols.ItemCreated]: getCurrentUTCDate(),
      [SurveyFormCols.ItemCreatedBy]: USER_ID,
      [SurveyFormCols.ItemGUID]: surveyDetails?.ItemGUID,
      [SurveyFormCols.ItemModified]: getCurrentUTCDate(),
      [SurveyFormCols.ItemModifiedBy]: USER_ID,
      [SurveyFormCols.MAJCOM]: surveyDetails?.MAJCOM,
      [SurveyFormCols.MPFMadeItEasyForMe]: selectedAnswers[SurveyFormCols.MPFMadeItEasyForMe],
      [SurveyFormCols.OverallSatisfactionForTheResolution]:
        selectedAnswers[SurveyFormCols.OverallSatisfactionForTheResolution],
      [SurveyFormCols.SatisfactionOnQualityOfYourService]:
        selectedAnswers[SurveyFormCols.SatisfactionOnQualityOfYourService],
      [SurveyFormCols.SatisfactionOnResolutionTimeliness]:
        selectedAnswers[SurveyFormCols.SatisfactionOnResolutionTimeliness],
      [SurveyFormCols.ServicingOrganization]: surveyDetails?.ServicingOrganization,
      [SurveyFormCols.SurveyGUID]: surveyDetails?.SurveyGUID
    }
      setflagvalue(updateSurveyRequired, addSurveyRequired)
  }
  const setflagvalue = async (updateSurveyRequired, addSurveyRequired) => {
    const surveyFormList = await mpfRListsHttp().getList(SURVEY_FORM_LIST)
    const surveyRequiredList = await mpfRListsHttp().getList(SURVEY_REQUIRED_LIST)
    await surveyRequiredList.addOrUpdateItem(updateSurveyRequired)
    await surveyFormList.addOrUpdateItem(addSurveyRequired)
    setThanksMessage(true)
  }

  const closeTab = () => {
    const customWindow = window.open('', '_blank', '')
    customWindow?.close()
    navigate('/')
  }

  return (
    <>
      {thanksMessage && <div id='overlay'></div>}
      <div className='DeltaPlaceHolderMain'>
        <div className='divWarningContent'>
          <div className='divcontainer'>
            {/* <p aria-label={SITECUI} tabIndex={0}>
              {SITECUI}
            </p> */}
          </div>

        </div>
        <div className='survey-wrapper'>
          {/* <div className='header'>
            <div className='header-inner'>
              <div className='feedback-logo mt-3'>
                <img alt='Comptroller Services Portal' data-themekey='#' src={logo} />
              </div>
            </div>
          </div>  */}
          <div className='graphicbg'></div>
          <div className='sureymainposition'>
            <div className='bodycontainer'>
              <div className='headcontent'>
                <h1>
                  {' '}
                  <span>
                    {' '}
                    <svg
                      height='43.213'
                      viewBox='0 0 48.015 43.213'                      
                      width='48.015'
                      xmlns='http://www.w3.org/2000/svg'
                    >
                      <g id='noun_feedback_2044720' transform='translate(0 0)'>
                        <g data-name='Group 24629' id='Group_24629' transform='translate(0 0)'>
                          <path
                            d='M73.255,17.153l-4.8-4.8a1.2,1.2,0,0,0-1.7,0l-14.4,14.4A1.2,1.2,0,0,0,52,27.6v4.8a1.2,1.2,0,0,0,1.2,1.2H58a1.2,1.2,0,0,0,.849-.352l14.4-14.4A1.2,1.2,0,0,0,73.255,17.153ZM57.5,31.206H54.4V28.1L67.6,14.9l3.1,3.1Z'
                            data-name='Path 16685'
                            fill='#fff'
                            id='Path_16685'
                            transform='translate(-25.592 -12)'
                          />
                          <path
                            d='M33.2,32h-12a1.2,1.2,0,0,0,0,2.4h12a1.2,1.2,0,0,0,0-2.4Z'
                            data-name='Path 16686'
                            fill='#fff'
                            id='Path_16686'
                            transform='translate(-12.798 -19.996)'
                          />
                          <path
                            d='M21.2,46.4h12a1.2,1.2,0,1,0,0-2.4h-12a1.2,1.2,0,1,0,0,2.4Z'
                            data-name='Path 16687'
                            fill='#fff'
                            id='Path_16687'
                            transform='translate(-12.798 -24.794)'
                          />
                          <path
                            d='M21.2,58.4H45.208a1.2,1.2,0,1,0,0-2.4H21.2a1.2,1.2,0,1,0,0,2.4Z'
                            data-name='Path 16688'
                            fill='#fff'
                            id='Path_16688'
                            transform='translate(-12.798 -29.592)'
                          />
                          <path
                            d='M47.612,36.805a1.2,1.2,0,0,0-1.2,1.2v7.2a3.605,3.605,0,0,1-3.6,3.6h-12a1.2,1.2,0,0,0-.72.24L22.4,54.811v-4.8a1.2,1.2,0,0,0-1.2-1.2H14a3.605,3.605,0,0,1-3.6-3.6V26A3.605,3.605,0,0,1,14,22.4H35.609a1.2,1.2,0,0,0,0-2.4H14a6.009,6.009,0,0,0-6,6V45.208a6.009,6.009,0,0,0,6,6h6v6a1.2,1.2,0,0,0,1.92.96l9.283-6.962h11.6a6.009,6.009,0,0,0,6-6v-7.2a1.2,1.2,0,0,0-1.2-1.2Z'
                            data-name='Path 16689'
                            fill='#fff'
                            id='Path_16689'
                            transform='translate(-8 -15.199)'
                          />
                        </g>
                      </g>
                    </svg>
                  </span>
                  Customer Satisfaction Survey
                </h1>
                <div className='ratingbg'>
                  <span className='rating-star full-star'></span>
                  <span className='rating-star full-star'></span>
                  <span className='rating-star full-star'></span>
                  <span className='rating-star full-star'></span>
                  <span className='rating-star empty-star'></span>
                </div>
              </div>
              {!thanksMessage && (
                <div className='content-bg' id='surveyformpage'>
                  <div className='feedbackheader'>
                    <div className='feedbackcontent'>
                      <h2>We would love to hear your feedback!</h2>
                    </div>
                  </div>
                  <div className='inquiryinfo'>
                    <p className='inquiryid'>
                      Inquiry id -{' '}
                      <a
                        href={
                           `/detailview/${surveyDetails?.ItemGUID}`
                        }
                        rel='noreferrer'
                        target='_blank' title={inquiryID}
                      >
                        {/*  <a id="surveyinquiryid" target="_blank">{inquiryID}</a> */}
                        {defaultToEmptyString(inquiryID)}
                      </a>
                    </p>
                    <p className='hint'>
                      <span className='mandatory mandatoryHeader'> * </span>
                      All questions/statements are mandatory except the optional text box.
                    </p>
                  </div>
                  {!isRequired && !showAnswers && (
                    <div
                      aria-describedby='dialog-confirm'
                      aria-labelledby='ui-id-1'
                      className='ui-dialog ui-corner-all ui-widget ui-widget-content ui-front ui-dialog-buttons'
                      id='dialog'
                      role='dialog'
                      tabIndex={0}
                    >
                      <div className='ui-dialog-titlebar ui-corner-all ui-widget-header ui-helper-clearfix'>
                        <span className='ui-dialog-title' id='ui-id-1'>
                          &nbsp;
                        </span>
                        <button className='ui-dialog-titlebar-close' type='button'></button>
                      </div>
                      <div className='ui-dialog-content ui-widget-content' id='dialog-confirm'>
                        <p>
                        &quot;You have already completed the survey for this inquiry.
                        &quot;Do you want to view your response?
                        </p>
                      </div>
                      <div className='ui-dialog-buttonpane ui-widget-content ui-helper-clearfix'>
                        <div className='ui-dialog-buttonset'>
                          <button
                            aria-label='Yes'
                            onClick={() => setShowAnswers(true)}
                            type='button'
                          >
                            Yes
                          </button>
                          <button aria-label='No' onClick={() => closeTab()} type='button'>
                            No
                          </button>
                        </div>
                      </div>
                    </div>
                  )}

                  <ul className='questions'>
                    {Object.keys(surveyQuestions).map((key) => {
                      return buildQuestions(key)
                    })}

                    <li className='topContainer' id='AddiotnalCommentli'>
                      <p className='commentBoxTitle'>
                        Use the text box below to provide any additional comments.{' '}
                      </p>
                      <span className='info-icon'>
                        <svg
                          height='18'
                          viewBox='0 0 20.649 20.649'
                          width='18'
                          xmlns='http://www.w3.org/2000/svg'
                        >
                          <path
                            d='M9.292,13.422h2.065v2.065H9.292Zm0-8.259h2.065v6.195H9.292ZM10.314,0A10.324,10.324,0,1,0,20.649,10.324,10.319,10.319,0,0,0,10.314,0Zm.01,18.584a8.259,8.259,0,1,1,8.259-8.259A8.257,8.257,0,0,1,10.324,18.584Z'
                            fill='#0257a5'
                            id='ic_error_outline_24px'
                            transform='translate(20.649 20.649) rotate(180)'
                          />
                        </svg>
                        <span className='info-tooltip'>
                          <span className='classic'>
                            <span className='tooltipdescp'>
                              <p>Please provide any additional comments.</p>
                            </span>
                          </span>
                        </span>
                      </span>
                      <textarea
                        aria-label='Additional Comments'
                        aria-required='true'
                        className='descriptionarea formcontrol'
                        cols={7}
                        disabled={isDisabled}
                        id='AdditionalComments'
                        maxLength={600}
                        name='Additional Comments'
                        onChangeCapture={handleComment}
                        rows={5}
                        spellCheck='true'
                        value={aditionalComment}
                      ></textarea>
                    </li>
                  </ul>
                  <div className='feedbackfooter'>
                    <div className='actionbtns'>
                      <ul>
                        <li>
                          <a
                            className='SurveyCancelbtn'
                            href='javascript:void(0);'
                            onClick={() => closeTab()}
                            title='Cancel'
                          >
                            {' '}
                            <span>
                              <svg
                                height='11.504'
                                viewBox='0 0 13.504 13.504'
                                width='13.504'
                                xmlns='http://www.w3.org/2000/svg'
                              >
                                <path
                                  d='M18.5,6.36,17.144,5l-5.392,5.392L6.36,5,5,6.36l5.392,5.392L5,17.144,6.36,18.5l5.392-5.392L17.144,18.5l1.36-1.36-5.392-5.392Z'
                                  fill='#fff'
                                  id='ic_clear_24px'
                                  transform='translate(-5 -5)'
                                />
                              </svg>
                            </span>{' '}
                            CANCEL
                          </a>
                        </li>
                        {isRequired && (
                          <li>
                            <a
                              className='SurveySubmitbtn'
                              href='javascript:void(0);'
                              onClick={() => submitSurveyForm()}
                              title='Submit'
                            >
                              {' '}
                              <span>
                                <svg
                                  height='11.949'
                                  viewBox='0 0 17.274 12.949'
                                  width='17.274'
                                  xmlns='http://www.w3.org/2000/svg'
                                >
                                  <g
                                    data-name='Group 12584'
                                    id='Group_12584'
                                    transform='translate(-0.539 -4.041)'
                                  >
                                    <path
                                      d='M1.433,11.612l5.018,5.141L16.938,6.466'
                                      data-name='Path 17552'
                                      fill='none'
                                      id='Path_17552'
                                      stroke='#fff'
                                      strokeWidth='2.5'
                                      transform='translate(0 -1.532)'
                                    />
                                  </g>
                                </svg>
                              </span>{' '}
                              SUBMIT
                            </a>
                          </li>
                        )}
                      </ul>
                    </div>
                  </div>
                </div>
              )}

              {thanksMessage && (
                <div className='content-bg closingCard' id='thankyoumsg'>
                  <a
                    className='closeButton'
                    href='javascript:void(0);'
                    onClick={() => closeTab()}
                    title='Close'
                  >
                    𐌗 Close
                  </a>
                  <div className='thankyoumsg'>
                    <span className='thankyou-icon'>
                      <svg
                        height='73.027'
                        id='tick'
                        viewBox='0 0 73.027 73.027'
                        width='73.027'
                        xmlns='http://www.w3.org/2000/svg'
                      >
                        <circle
                          cx='36.514'
                          cy='36.514'
                          data-name='Ellipse 2363'
                          fill='#32ba7c'
                          id='Ellipse_2363'
                          r='36.514'
                        />
                        <path
                          d='M188.8,183.1l18.775,18.775a36.49,36.49,0,0,0,27.069-35.247v-1.037L219.9,152Z'
                          data-name='Path 16694'
                          fill='#0aa06e'
                          id='Path_16694'
                          transform='translate(-161.616 -130.115)'
                        />
                        <g
                          data-name='Group 25488'
                          id='Group_25488'
                          transform='translate(12.267 18.026)'
                        >
                          <path
                            d='M110.368,215.553a4.313,4.313,0,0,1,0,5.99l-3.34,3.34a4.313,4.313,0,0,1-5.99,0L86.409,210.139a4.313,4.313,0,0,1,0-5.99l3.34-3.34a4.313,4.313,0,0,1,5.99,0Z'
                            data-name='Path 16695'
                            fill='#fff'
                            id='Path_16695'
                            transform='translate(-85.2 -188.888)'
                          />
                          <path
                            d='M190.95,126.409a4.313,4.313,0,0,1,5.99,0l3.34,3.34a4.313,4.313,0,0,1,0,5.99l-25.341,25.226a4.313,4.313,0,0,1-5.99,0l-3.34-3.34a4.313,4.313,0,0,1,0-5.99Z'
                            data-name='Path 16696'
                            fill='#fff'
                            id='Path_16696'
                            transform='translate(-152.997 -125.2)'
                          />
                        </g>
                      </svg>
                    </span>
                    <h1
                      aria-label='Thank you very much for taking the time to send us your 
                                feedback.'
                      tabIndex={0}
                    >
                      Thank you very much for taking the time to send us your feedback.
                    </h1>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
export default SurveyForm
